import paymentCards from "@/assets/payment-cards.png";

export const PaymentMethods = () => {
  return (
    <div className="flex items-center justify-center">
      <img 
        src={paymentCards} 
        alt="Amex, Mastercard, Visa" 
        className="h-8 w-auto"
        width={114}
        height={32}
        loading="lazy"
      />
    </div>
  );
};
